// extracted by mini-css-extract-plugin
module.exports = {"bg":"ModalWide_bg__ihIw4","close":"ModalWide_close__3yNh3","overlay":"ModalWide_overlay__2BFR2"};